import Tab from '../../components/Tab/Tab';
import styles from './Services.module.scss';
import FaleConosco from '../../components/FaleConosco/FaleConosco';
import { useEffect, useState } from 'react';
import { servicesContents } from '../../data/services';
import { ServiceKeys } from '../../interfaces/IServices';
import DownArrow from '../../assets/icons/down-white-arrow.png';
import UpArrow from '../../assets/icons/up-white-arrow.png';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

interface ISelectedService {
    title: string;
    description: string;
}

export default function Services() {
    const [service, setService] = useState<ServiceKeys>('datacenter');
    const [showProducts, setShowProducts] = useState(false);
    const [selectedService, setSelectedService] = useState<ISelectedService | undefined>(undefined);
    const navigate = useNavigate();

    useEffect(() => {
        setSelectedService(undefined);
    }, [service]);

    const findService = (title: string) => {
        const result = servicesContents[service].find((item) => item.title.toLowerCase() === title);

        setSelectedService(result);
    };

    return (
        <>
            <Tab onServiceClick={setService} />
            <section className={styles.product_list_container}>
                <div className={styles.banner_container}>
                    <nav className={styles.navigation}>
                        <ul>
                            {servicesContents[service].map((item, index) => (
                                <>
                                    <li
                                        className={
                                            selectedService?.title.toLowerCase() ===
                                            item.title.toLowerCase()
                                                ? styles.selected_nav
                                                : ''
                                        }
                                        onClick={() => findService(item.title.toLowerCase())}
                                    >
                                        {item.title}
                                    </li>
                                    {index < servicesContents[service].length - 1 && <div></div>}
                                </>
                            ))}
                        </ul>
                    </nav>
                </div>
            </section>

            <section className={styles.product_list_mobile}>
                <div className={styles.arrow_box} onClick={() => setShowProducts(!showProducts)}>
                    {showProducts ? (
                        <img src={UpArrow} alt="Seta para baixo" />
                    ) : (
                        <img src={DownArrow} alt="Seta para baixo" />
                    )}
                </div>

                <nav
                    className={`${styles.navigation} ${
                        showProducts ? styles.active : styles.inactive
                    }`}
                >
                    <ul>
                        {servicesContents[service].map((item, index) => (
                            <>
                                <li
                                    className={
                                        selectedService?.title.toLowerCase() ===
                                        item.title.toLowerCase()
                                            ? styles.selected_nav
                                            : ''
                                    }
                                    onClick={() => findService(item.title.toLowerCase())}
                                    key={index}
                                >
                                    {item.title}
                                </li>
                                {index < servicesContents[service].length - 1 && <div></div>}
                            </>
                        ))}
                    </ul>
                </nav>
            </section>

            <section className={styles.cards_container}>
                <AnimatePresence mode="wait">
                    {selectedService ? (
                        <motion.div
                            key={selectedService.title}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.3 }}
                        >
                            <h2>{selectedService.title}</h2>
                            <div className={styles.cards_description}>
                                <p>{selectedService.description}</p>
                                <button onClick={() => void navigate('/contato')}>
                                    Saiba Mais
                                </button>
                            </div>
                        </motion.div>
                    ) : (
                        <motion.p
                            key="default"
                            className={styles.select_text}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.2 }}
                        >
                            Selecione Seu Produto...
                        </motion.p>
                    )}
                </AnimatePresence>
            </section>
            <FaleConosco />
        </>
    );
}
